// Hands a blob to the browser as a download. The generated file endpoints
// resolve to a File named by the server, so most callers pass
// `file, file.name`; callers that reshape the content name it themselves.
export function saveFile(blob: Blob, fileName: string): void {
  const anchor = document.createElement('a');
  anchor.href = URL.createObjectURL(blob);
  // Older Safari ignores `download`; a new tab is the fallback there.
  anchor.target = '_blank';
  anchor.download = fileName;
  anchor.click();
}
